import "core-js/modules/es.string.trim.js";
import { ref } from "vue";
export function useFloatingLabel(emit) {
  var labelState = ref("inline-label");
  function setInitialLabelState(value) {
    if (value != null && "".concat(value).length > 0) labelState.value = "floating-label";
  }
  var handleFocusIn = function handleFocusIn() {
    var autoFloating = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (labelState.value !== "floating-label" && autoFloating) labelState.value = "floating-label";
    emit("focusin");
  };
  function handleFocusOut(value) {
    var manual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var auto = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (value != undefined && "".concat(value).trim().length > 0 || !manual && !auto) {
      setFloatingLabel();
      emit("focusout");
      return;
    }
    setInlineLabel();
  }
  var setInlineLabel = () => {
    labelState.value = "inline-label";
  };
  var setFloatingLabel = () => {
    labelState.value = "floating-label";
  };
  return {
    labelState,
    setInitialLabelState,
    handleFocusIn,
    handleFocusOut,
    setInlineLabel,
    setFloatingLabel
  };
}